module.exports = __webpack_public_path__ + "img/3-3.c4a9bf43.svg";